import http, { url } from '../../http'

const API_URL = "exercise_ocupational_medical"

class OcupationalNewMedicineAPI {

  async save(ocupationalMedicine) {
    const response = await http(`${API_URL}/save`, 'POST', ocupationalMedicine)
    return response
  }

  async getAllNewMedicine() {
    const response = await http(`${API_URL}`)
    return response
  } 

  async getAllNewMedicineCompany(id) {
    const response = await http(`${API_URL}/companies/${id}`)
    return response
  } 
  
  async getRedirectNewMedicineCompany() {
    const response = await http(`${API_URL}/redirect_company`, 'POST')
    return response
  } 
}

export default new OcupationalNewMedicineAPI()